class LipscoreDisplay extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        /*
        if (window.lipscore.isInitialized()) {
            window.lipscore.reInitWidgets()
        }
        */

        /*
        this.innerHTML =
            `<div class="lipscore-rating-big"
    data-ls-product-name="Service reviews"
    data-ls-product-id="service_review"
    data-ls-product-url="https://www.houseofhealing.no/">
</div>`;
*/

 this.innerHTML =
            `<div class="lipscore-service-review-badge-starred"
    data-ls-widget-height="100px"
    data-ls-widget-width="100px"
</div>`;

        if (window.lipscore.isInitialized()) {
            window.lipscore.reInitWidgets()
        } else {
            window.lipscore.initWidgets()
        }
    }

}

customElements.define('footer-lipscore', LipscoreDisplay);